import PropertyDetailsPageContainer from './container';

export default PropertyDetailsPageContainer;
